import * as echarts from 'echarts';
import store from '@/store/index.js'; // 导入 Vuex store
console.log(store)
export const staticEchartsInit = function (name, value, value2) {
    //echarts 柱状图 颜色循环
    var colors = [
        "#0263ff",
        "#ff7723",
        "#8e30ff",
        "#174863",
        "#cd106b",
        "#62f0bf",
        "#feaa76",
    ];
    var $echarts = echarts;
    // 认证统计----------------------------------------------------------------------------------------------------------------------------
    var chartDom = document.getElementById("rz");
    var myChart = $echarts.init(chartDom);
    var option;

    option = {
        tooltip: {
            trigger: "axis",
        },
        legend: {
            data: store.state.userinfo.isSuper ? ["已认证", "未认证"] : ["已认证"],
            left: "0%",
            top: "0%",
        },
        grid: {
            top: "15%",
            left: "0%",
            right: "4%",
            bottom: "5%",
            containLabel: true,
        },
        xAxis: {
            type: "category",
            boundaryGap: false,
            data: name,
        },
        yAxis: {
            type: "value",
            minInterval: 1
        },
        series: store.state.userinfo.isSuper ? [{
            name: "已认证",
            type: "line",
            color: "#0f9cff",
            data: value,
        },
        {
            name: "未认证",
            type: "line",
            color: "#ccc",
            data: value2,
        },
        ] : [{
            name: "已认证",
            type: "line",
            color: "#0f9cff",
            data: value,
        }],
    };

    option && myChart.setOption(option);

}

export const useEchartsInit = function (name, value) {
    //echarts 柱状图 颜色循环
    var colors = [
        "#0263ff",
        "#ff7723",
        "#8e30ff",
        "#174863",
        "#cd106b",
        "#62f0bf",
        "#feaa76",
    ]
    var $echarts = echarts;
    // 平均使用时长----------------------------------------------------------------------------------------------------------------------------
    var chartDom = document.getElementById("time");
    var myChart = $echarts.init(chartDom);
    var option;
    var arr = value;

    var data = [];
    for (var i = 0; i < arr.length; i++) {
        let obj = {
            value: arr[i],
            itemStyle: {
                color: colors[i % colors.length],
            },
        };
        data.push(obj);
    }
    option = {
        xAxis: {
            type: "category",
            data: name,
        },
        yAxis: {
            type: "value",
        },
        grid: {
            top: "5%",
            left: "10%",
            right: "4%",
            bottom: "15%",
        },
        series: [{
            data: data,
            type: "bar",
        },],
        tooltip: {
            // trigger: 'axis',
            axisPointer: {
                // type: 'cross',
                label: {
                    backgroundColor: '#6a7985'
                }
            }
        }
    };

    option && myChart.setOption(option);


}
export const userEchartsInit = function (data) {
    //echarts 柱状图 颜色循环
    var colors = [
        "#0263ff",
        "#ff7723",
        "#8e30ff",
        "#174863",
        "#cd106b",
        "#62f0bf",
        "#feaa76",
    ]
    var $echarts = echarts;
    // 用户数据统计----------------------------------------------------------------------------------------------------------------------------
    var chartDom = document.getElementById("userNumber");
    var myChart = $echarts.init(chartDom);
    var option;

    let total = 0
    data.forEach(element => {
        total += element.value
    });

    option = {
        title: {
            text: '用户总数',
            subtext:
                total,
            left: 'center',
            top: '30%',
            textStyle: {
                fontSize: '16',
                fontWeight: '200',
                color: ' #333333'
            },
            subtextStyle: {
                fontSize: '18',
                fontWeight: 'bold',
                color: ' #333333'
            }
        },
        tooltip: {
            trigger: 'item'
        },
        legend: {
            // orient: 'vertical',
            // left: 'left',
            // bottom: '5%'
            left: '25%',
            right: "25%",
            bottom: '5%'
        },
        series: [{
            label: {
                normal: {
                    show: false
                }
            },
            type: 'pie',
            radius: [50, 90],
            top: '-25%',
            data: data,
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }],
        color: ['#0263ff', '#ff7723']
    };
    option && myChart.setOption(option);

}
export const userEchartsInit2 = function (data) {
    //echarts 柱状图 颜色循环
    var colors = [
        "#0263ff",
        "#ff7723",
        "#8e30ff",
        "#174863",
        "#cd106b",
        "#62f0bf",
        "#feaa76",
    ]
    var $echarts = echarts;

    // 认证用户角色统计----------------------------------------------------------------------------------------------------------------------------
    var option;
    let total = 0
    data.forEach(element => {
        total += element.value
    });
    var chartDom = document.getElementById("userRole");
    var myChart = $echarts.init(chartDom);
    option = {
        title: {
            text: '认证用户',
            subtext: total,
            left: 'center',
            top: '30%',
            textStyle: {
                fontSize: '16',
                fontWeight: '200',
                color: ' #333333'
            },
            subtextStyle: {
                fontSize: '18',
                fontWeight: 'bold',
                color: ' #333333'
            }
        },
        tooltip: {
            trigger: 'item',
            formatter: '{b} : {c} ({d}%)', //鼠标移上数据显示内容
        },
        legend: {
            // orient: 'vertical',
            left: '25%',
            right: "25%",
            bottom: '5%'

        },
        series: [{
            label: {
                normal: {
                    show: false
                }
            },
            type: 'pie',
            radius: [50, 90],
            top: '-25%',
            data: data,
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }],
        color: ['#2e9bff', '#ff5757', "#e5da2f", "#9c5347", "#66c3d1"]
    };


    option && myChart.setOption(option);
}
export const userEchartsInit3 = function (data) {
    //echarts 柱状图 颜色循环
    var colors = [
        "#0263ff",
        "#ff7723",
        "#8e30ff",
        "#174863",
        "#cd106b",
        "#62f0bf",
        "#feaa76",
    ]
    var $echarts = echarts;

    var option;


    // 用户年龄统计环形图----------------------------------------------------------------------------------------------------------------------------

    var chartDom = document.getElementById("userAge");
    var myChart = $echarts.init(chartDom);
    option = {
        tooltip: {
            trigger: 'item',
            formatter: '{b} : {c} ({d}%)', //鼠标移上数据显示内容
        },
        legend: {
            // orient: 'vertical',
            left: '25%',
            right: "25%",
            bottom: '5%'

        },
        series: [{
            label: {
                normal: {
                    show: false
                }
            },
            type: 'pie',
            radius: [50, 90],
            top: '-25%',
            data: data,
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }],
        color: ['#35a8fd', '#ff6f00', "#fc7683", "#fdd036", "#4970fe"]
    };
    option && myChart.setOption(option);


}
export const userEchartsInit4 = function (data) {
    //echarts 柱状图 颜色循环
    var colors = [
        "#0263ff",
        "#ff7723",
        "#8e30ff",
        "#174863",
        "#cd106b",
        "#62f0bf",
        "#feaa76",
    ]
    var $echarts = echarts;

    var option;

    // 用户周活跃度统计----------------------------------------------------------------------------------------------------------------------------

    var chartDom = document.getElementById("userActive");
    var myChart = $echarts.init(chartDom);
    option = {
        tooltip: {
            trigger: 'item',
            formatter: '{b} : {c} ({d}%)', //鼠标移上数据显示内容
        },
        legend: {
            // orient: 'vertical',
            left: '25%',
            right: "25%",
            bottom: '5%'

        },
        series: [{
            label: {
                normal: {
                    show: false
                }
            },
            type: 'pie',
            radius: [50, 90],
            top: '-25%',
            data: data,
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }],
        color: ['#9ad9f6', '#ff7723', "#f9ae2c"]
    };
    option && myChart.setOption(option);



}
export const publishEchartsInit = function (name, value) {
    //echarts 柱状图 颜色循环
    var colors = [
        "#0263ff",
        "#ff7723",
        "#8e30ff",
        "#174863",
        "#cd106b",
        "#62f0bf",
        "#feaa76",
    ]
    var $echarts = echarts;

    var option;
    // 内容发布量趋势----------------------------------------------------------------------------------------------------------------------------


    var chartDom = document.getElementById("contentRelease");
    var myChart = $echarts.init(chartDom);

    option = {
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: name,
        },
        tooltip: {
            trigger: "axis",
            formatter: '发布量：{c}'
        },
        yAxis: {
            type: 'value'
        },
        series: [{
            data: value,
            type: 'line',
            areaStyle: {}
        }],
        color: ['#68b3ff']
    };
    option && myChart.setOption(option);

}



// WEBPACK FOOTER //
// ./src/view/echartsInit.js